import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import user from './modules/user'
import { createStore as createSearchStore } from './modules/search'

export default new Vuex.Store({
  modules: {
    user,
    search: createSearchStore()
  }
})



// WEBPACK FOOTER //
// ./src/js/shared/store/index.js